var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "payment-loading-overlay"
};
const _hoisted_2 = { class: "payment-loading-card" };
const _hoisted_3 = { class: "payment-loading-title" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "footerFixed" };
const _hoisted_6 = {
    id: "all_wrapper",
    class: "user_home"
};
const _hoisted_7 = { class: "wrapper_1" };
const _hoisted_8 = {
    key: 0,
    class: "alert alert-info alert-dismissible",
    id: "alert-box"
};
const _hoisted_9 = { class: "alert-text" };
const _hoisted_10 = { class: "h_box" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { key: 2 };
const _hoisted_14 = { class: "h_right" };
const _hoisted_15 = {
    key: 0,
    style: { "color": "red", "font-size": "19px", "border": "solid 1px red", "padding": "15px", "margin": "0px 15px" }
};
const _hoisted_16 = { class: "inner search_box" };
const _hoisted_17 = { class: "nav" };
const _hoisted_18 = { style: { "cursor": "pointer" } };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
    key: 0,
    class: "point"
};
const _hoisted_21 = { class: "condition" };
const _hoisted_22 = { class: "sel_wrapper" };
const _hoisted_23 = ["value"];
const _hoisted_24 = { class: "sel_wrapper" };
const _hoisted_25 = ["value"];
const _hoisted_26 = { class: "comment_box" };
const _hoisted_27 = { class: "inner" };
const _hoisted_28 = {
    key: 0,
    class: "check"
};
const _hoisted_29 = { class: "prof" };
const _hoisted_30 = { class: "left" };
const _hoisted_31 = { class: "ph" };
const _hoisted_32 = { class: "ca_1" };
const _hoisted_33 = { class: "ca_2" };
const _hoisted_34 = { class: "right" };
const _hoisted_35 = {
    key: 0,
    class: "ca_1"
};
const _hoisted_36 = {
    key: 1,
    class: "ca_3"
};
const _hoisted_37 = {
    key: 2,
    class: "ca_2"
};
const _hoisted_38 = { class: "w_box" };
const _hoisted_39 = ["href"];
const _hoisted_40 = ["href"];
const _hoisted_41 = { class: "under" };
const _hoisted_42 = { class: "left" };
const _hoisted_43 = { class: "answer" };
const _hoisted_44 = { class: "heart" };
const _hoisted_45 = { class: "right" };
import { inject, ref, watch, computed, onBeforeMount, onMounted, nextTick } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import { AuthRole, QuestionType } from '@util/Consts';
import JobsModal from '@component/Modals/UserHome/JobModal.vue';
import ImageFrame from '@component/ImageFrame.vue';
import Pagination from '@component/QuestionPagination.vue';
import swal from 'sweetalert';
import { loadStripe } from '@stripe/stripe-js';
const USER_HOME_SEARCH_SESSION_KEY = 'user-home-search';
const MAX_UNREAD_COUNT = 99;
export default /*@__PURE__*/ _defineComponent({
    __name: 'user_home',
    props: {
        common: {},
        checkExpire: {},
        additionalQuestionMsg: {},
        questions: {},
        question_option_types: {},
        unread_reply_question_count: {},
        success_message: {},
        createQuestionAvailable: {},
        payment_intent_client_secret: {}
    },
    setup(__props) {
        const props = __props;
        let stripe = null;
        const form = InertiaUtil.getForm({
            job_group_id: null,
            job_id: null,
            other_job_name: '',
            option_type: null,
            question_type_id: null,
            industry_id: null,
            mentor_type: null,
            keyword: null,
        });
        const typeOptions = ref([]);
        const industryOptions = ref([]);
        const jobOptions = ref([]);
        const auth_3ds_complete = ref('loading');
        const loadingTitle = ref('決済処理中です'); // 3DS認証後のローディング表示用
        const showUnread = computed(() => props.unread_reply_question_count <= MAX_UNREAD_COUNT
            ? props.unread_reply_question_count.toString()
            : `${MAX_UNREAD_COUNT}+`);
        // 文字数チェック
        watch(() => form.keyword, (value) => {
            if (Alert.charLimitText(value)) {
                form.keyword = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const onClickTo3DSpage = () => {
            Inertia.get(route('user.3ds_confirm'));
        };
        // 今月分の基本料金が未払い → 支払方法登録画面で支払いダイアログを自動表示（?pay=1）
        const onClickToPlanPage = () => {
            Inertia.get(route('payment.show', { pay: 1 }));
        };
        // メンター職種選択イベント
        const onSelectedJob = (job) => {
            var _a, _b, _c;
            form.job_group_id = (_a = job === null || job === void 0 ? void 0 : job.job_group_id) !== null && _a !== void 0 ? _a : '';
            form.job_id = (_b = job === null || job === void 0 ? void 0 : job.job_id) !== null && _b !== void 0 ? _b : '';
            form.other_job_name = (_c = job === null || job === void 0 ? void 0 : job.other_job_name) !== null && _c !== void 0 ? _c : '';
        };
        // 検索
        const onClickSearch = () => {
            sessionStorage.setItem(USER_HOME_SEARCH_SESSION_KEY, JSON.stringify(form));
            form.get(route('question.index'), { preserveState: true });
        };
        const onClickQuestionType = (type) => {
            form.option_type = type.toString();
            sessionStorage.setItem(USER_HOME_SEARCH_SESSION_KEY, JSON.stringify(form));
            form.get(route('question.index'), {});
        };
        const onClickCloseAlert = () => {
            document.getElementById('alert-box').style.display = 'none';
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            const publishableKey = inject('stripePublicKey');
            const secretKey = inject('stripeSecretKey');
            const stripePromise = loadStripe(publishableKey);
            const stripe = yield stripePromise;
            if (props.payment_intent_client_secret) {
                // 3DS2認証完了後の処理（2段階ポーリング方式）
                // Stage 1: 決済完了確認（最大30秒、1秒間隔でStripeステータスをポーリング）
                // Stage 2: 相談レコード登録完了確認（最大10秒、1秒間隔でDB存在確認APIをポーリング）
                const payment_intent_client_secret = props.payment_intent_client_secret;
                // === Stage 1: 決済完了確認 ===
                loadingTitle.value = "決済処理中です";
                const initialResult = yield stripe.retrievePaymentIntent(payment_intent_client_secret);
                if (initialResult.error) {
                    // SDK/通信エラー（client_secret不正など）
                    auth_3ds_complete.value = "failed";
                    Alert.Error("決済状態の確認中にエラーが発生しました。時間をおいて相談一覧をご確認ください。");
                }
                else {
                    let paymentIntent = initialResult.paymentIntent;
                    let paymentStatus;
                    if (paymentIntent.status === 'succeeded') {
                        paymentStatus = 'succeeded';
                    }
                    else if (paymentIntent.status === 'requires_payment_method') {
                        paymentStatus = 'payment_failed';
                    }
                    else {
                        // processing / requires_action などは30秒ポーリング
                        const pollResult = yield pollPaymentStatus(stripe, payment_intent_client_secret, 30);
                        paymentStatus = pollResult.status;
                        if (pollResult.paymentIntent) {
                            paymentIntent = pollResult.paymentIntent;
                        }
                    }
                    if (paymentStatus === 'payment_failed') {
                        // 認証失敗（既存動作維持）
                        Inertia.get(route('question.confirm'));
                        swal({
                            title: "確認",
                            text: "クレジットカードの認証に失敗し、相談は受付られませんでした。必要により支払方法登録画面で別カードの登録をご検討ください。",
                            icon: "warning",
                            buttons: {
                                ok: {
                                    text: "OK",
                                    className: "timeout-ok-btn",
                                },
                            },
                        }).then(() => {
                            auth_3ds_complete.value = "failed";
                        });
                    }
                    else if (paymentStatus === 'timeout') {
                        // Stage 1 タイムアウト：30秒経っても決済が確定しない
                        sessionStorage.removeItem('oldQuestionForm');
                        auth_3ds_complete.value = "failed"; // ローディングオーバーレイを閉じる
                        swal({
                            title: "確認",
                            text: "クレジットカードの認証中です。認証に成功したら相談が登録されます。しばらくお待ちください。",
                            icon: "info",
                            buttons: {
                                ok: {
                                    text: "OK",
                                    className: "timeout-ok-btn",
                                },
                            },
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                    else if (paymentStatus === 'succeeded') {
                        // === Stage 2: 相談レコード登録完了確認 ===
                        sessionStorage.removeItem('oldQuestionForm');
                        loadingTitle.value = "相談投稿中です";
                        const paymentIntentId = paymentIntent.id;
                        const questionCreated = yield pollQuestionCreation(paymentIntentId, 10);
                        if (questionCreated) {
                            // 相談レコードがDBに登録済み → 最新一覧を表示するためリロード
                            window.location.reload();
                        }
                        else {
                            // Stage 2 タイムアウト：決済は成功したが相談レコードがまだDB未登録
                            auth_3ds_complete.value = "failed";
                            swal({
                                title: "確認",
                                text: "相談の投稿中です。しばらくお待ちください。",
                                icon: "info",
                                buttons: {
                                    ok: {
                                        text: "OK",
                                        className: "timeout-ok-btn",
                                    },
                                },
                            }).then(() => {
                                window.location.reload();
                            });
                        }
                    }
                }
            }
            else {
                // this means no 3ds auth case
                auth_3ds_complete.value = "success";
            }
            if (props.checkExpire) {
                Alert.Error(props.checkExpire);
            }
            ;
            if (props.additionalQuestionMsg) {
                Alert.Error(props.additionalQuestionMsg);
            }
            ;
            const [types, industries, jobs] = yield Promise.all([
                axios
                    .get('/question-types-trashed')
                    .then(res => res.data)
                    .catch(e => {
                    console.error('Failed to load question-types-trashed:', e);
                    return [];
                }),
                axios
                    .get('/industries')
                    .then(res => res.data)
                    .catch(e => {
                    console.error('Failed to load industries:', e);
                    return [];
                }),
                axios
                    .get('/jobs')
                    .then(res => res.data)
                    .catch(e => {
                    console.error('Failed to load jobs:', e);
                    return [];
                }),
            ]);
            typeOptions.value = types;
            industryOptions.value = industries;
            jobOptions.value = jobs;
        }));
        // モーダル初期化関数
        const initModal = () => {
            // 既に読み込まれていたら一旦削除して、読み込み直す。
            var key = require.resolve('@jquery/modal-jquery');
            if (key)
                delete require.cache[key];
            require('@jquery/modal-jquery');
        };
        // ======== 3DS2認証後のポーリング用ヘルパー ========
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        /**
         * Stage 1: Stripe PaymentIntent のステータスを最大 maxSeconds 秒間（1秒間隔）ポーリング
         * @returns { status: 'succeeded' | 'payment_failed' | 'timeout', paymentIntent: object | null }
         */
        const pollPaymentStatus = (stripeInstance, clientSecret, maxSeconds) => __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < maxSeconds; i++) {
                yield sleep(1000);
                try {
                    const { paymentIntent, error } = yield stripeInstance.retrievePaymentIntent(clientSecret);
                    if (error)
                        continue; // 一時的エラーはリトライ
                    if (paymentIntent.status === 'succeeded') {
                        return { status: 'succeeded', paymentIntent };
                    }
                    if (paymentIntent.status === 'payment_failed' ||
                        paymentIntent.status === 'requires_payment_method') {
                        return { status: 'payment_failed', paymentIntent };
                    }
                }
                catch (e) {
                    // ネットワークエラー等はリトライ
                }
            }
            return { status: 'timeout', paymentIntent: null };
        });
        /**
         * Stage 2: 追加質問の相談レコードが DB に登録されたかを最大 maxSeconds 秒間（1秒間隔）ポーリング
         * @returns true: 登録確認済 / false: タイムアウト
         */
        const pollQuestionCreation = (paymentIntentId, maxSeconds) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            for (let i = 0; i < maxSeconds; i++) {
                try {
                    const response = yield axios.get('/question/check-by-payment', {
                        params: { payment_intent_id: paymentIntentId }
                    });
                    if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.exists)
                        return true;
                }
                catch (e) {
                    // ネットワークエラー等はリトライ
                }
                yield sleep(1000);
            }
            return false;
        });
        // auth_3ds_completeがloadingから変化したらモーダルを初期化
        watch(() => auth_3ds_complete.value, (newValue, oldValue) => {
            if (oldValue === 'loading' && newValue !== 'loading') {
                nextTick(() => {
                    initModal();
                });
            }
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            const storage = JSON.parse(sessionStorage.getItem(USER_HOME_SEARCH_SESSION_KEY));
            nextTick(() => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                // auth_3ds_completeがloadingでない場合のみモーダルを初期化
                if (auth_3ds_complete.value !== 'loading') {
                    initModal();
                }
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                form.option_type = (_b = (_a = storage === null || storage === void 0 ? void 0 : storage.option_type) !== null && _a !== void 0 ? _a : params.get('option_type')) !== null && _b !== void 0 ? _b : QuestionType.ALL.toString();
                form.job_group_id = (_c = storage === null || storage === void 0 ? void 0 : storage.job_group_id) !== null && _c !== void 0 ? _c : params.get('job_group_id');
                form.job_id = (_d = storage === null || storage === void 0 ? void 0 : storage.job_id) !== null && _d !== void 0 ? _d : params.get('job_id');
                form.question_type_id = (_e = storage === null || storage === void 0 ? void 0 : storage.question_type_id) !== null && _e !== void 0 ? _e : params.get('question_type_id');
                form.industry_id = (_f = storage === null || storage === void 0 ? void 0 : storage.industry_id) !== null && _f !== void 0 ? _f : params.get('industry_id');
                form.mentor_type = (_g = storage === null || storage === void 0 ? void 0 : storage.mentor_type) !== null && _g !== void 0 ? _g : params.get('mentor_type');
                form.keyword = (_h = storage === null || storage === void 0 ? void 0 : storage.keyword) !== null && _h !== void 0 ? _h : params.get('keyword');
            });
        }));
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (auth_3ds_complete.value === 'loading' && props.payment_intent_client_secret)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "payment-loading-spinner" }, null, -1)),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(loadingTitle.value), 1),
                            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "payment-loading-subtitle" }, "しばらくお待ちください。", -1))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (auth_3ds_complete.value !== 'loading')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(headerVue, {
                            common: props.common
                        }, null, 8, ["common"]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    (props.success_message)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("p", _hoisted_9, _toDisplayString(props.success_message), 1),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "close",
                                                onClick: onClickCloseAlert
                                            }, _cache[7] || (_cache[7] = [
                                                _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                                            ]))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_10, [
                                        (props.common.role === _unref(AuthRole).QUESTIONER)
                                            ? (_openBlock(), _createElementBlock("h2", _hoisted_11, "相談者ホーム"))
                                            : (props.common.role === _unref(AuthRole).MENTOR)
                                                ? (_openBlock(), _createElementBlock("h2", _hoisted_12, "メンターホーム"))
                                                : (_openBlock(), _createElementBlock("h2", _hoisted_13, "管理者ホーム")),
                                        _createElementVNode("div", _hoisted_14, [
                                            (!(props.common.role === _unref(AuthRole).MENTOR || props.common.role === _unref(AuthRole).ADMIN))
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (props.createQuestionAvailable)
                                                        ? (_openBlock(), _createBlock(_unref(Link), {
                                                            key: 0,
                                                            href: "/question/create"
                                                        }, {
                                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                _createTextVNode("相談する")
                                                            ])),
                                                            _: 1,
                                                            __: [8]
                                                        }))
                                                        : (_openBlock(), _createElementBlock("a", {
                                                            key: 1,
                                                            class: "disabled_link",
                                                            "aria-disabled": "true",
                                                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"]))
                                                        }, "相談する"))
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        (props.common.role === _unref(AuthRole).QUESTIONER && !props.createQuestionAvailable)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _cache[9] || (_cache[9] = _createTextVNode(" 今月分の基本料金のお支払いが完了していません。 ")),
                                                _createElementVNode("a", {
                                                    style: { "color": "red", "cursor": "pointer" },
                                                    onClick: onClickToPlanPage
                                                }, "こちら"),
                                                _cache[10] || (_cache[10] = _createTextVNode(" からお支払いを完了してください。 "))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("form", null, [
                                            _createElementVNode("ul", _hoisted_17, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.question_option_types, (value, key, _) => {
                                                    return (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                                        _createElementVNode("a", {
                                                            class: _normalizeClass({ active: key.toString() === _unref(form).option_type }),
                                                            onClick: ($event) => (onClickQuestionType(key))
                                                        }, [
                                                            _createTextVNode(_toDisplayString(value) + " ", 1),
                                                            (_unref(QuestionType).REPLY_UNREAD.toString() === key.toString() && props.unread_reply_question_count > 0)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(showUnread.value), 1))
                                                                : _createCommentVNode("", true)
                                                        ], 10, _hoisted_19)
                                                    ]));
                                                }), 256))
                                            ]),
                                            _createElementVNode("ul", _hoisted_21, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _cache[12] || (_cache[12] = _createElementVNode("p", null, "相談タイプ", -1)),
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).question_type_id) = $event)),
                                                            autofocus: ""
                                                        }, [
                                                            _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, null, -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (questionType) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    value: questionType.id
                                                                }, _toDisplayString(questionType.name), 9, _hoisted_23));
                                                            }), 256))
                                                        ], 512), [
                                                            [_vModelSelect, _unref(form).question_type_id]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _cache[14] || (_cache[14] = _createElementVNode("p", null, "相談者業種", -1)),
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).industry_id) = $event))
                                                        }, [
                                                            _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, null, -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryOptions.value, (industry) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    value: industry.id
                                                                }, _toDisplayString(industry.name), 9, _hoisted_25));
                                                            }), 256))
                                                        ], 512), [
                                                            [_vModelSelect, _unref(form).industry_id]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createVNode(JobsModal, {
                                                        form: _unref(form),
                                                        options: jobOptions.value,
                                                        placeholder: "対象メンター職種",
                                                        onSelected: onSelectedJob,
                                                        "max-length": 19
                                                    }, null, 8, ["form", "options"])
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).keyword) = $event)),
                                                        class: "",
                                                        type: "text",
                                                        placeholder: "キーワード入力",
                                                        id: "consultationRaw__input"
                                                    }, null, 512), [
                                                        [_vModelText, _unref(form).keyword]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("button", {
                                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (onClickSearch()), ["prevent"]))
                                            }, "検索")
                                        ])
                                    ]),
                                    _createVNode(Pagination, {
                                        questions: props.questions
                                    }, null, 8, ["questions"]),
                                    _createElementVNode("div", _hoisted_26, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = props.questions) === null || _a === void 0 ? void 0 : _a.data, (display) => {
                                            var _a, _b;
                                            return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                (!display.is_read)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("div", _hoisted_30, [
                                                        _createElementVNode("div", _hoisted_31, [
                                                            _createVNode(ImageFrame, {
                                                                src: display.user.photo
                                                            }, null, 8, ["src"])
                                                        ]),
                                                        _createVNode(_unref(Link), {
                                                            href: `/user/${display.user.id}`
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(display.user.name), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["href"]),
                                                        _createElementVNode("div", _hoisted_32, _toDisplayString((_a = display.user.industry) === null || _a === void 0 ? void 0 : _a.name), 1),
                                                        _createElementVNode("div", _hoisted_33, _toDisplayString((_b = display.question_type) === null || _b === void 0 ? void 0 : _b.name), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_34, [
                                                        (display.status == _unref(QuestionType).ACCEPTING)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, "受付中"))
                                                            : _createCommentVNode("", true),
                                                        (display.status == _unref(QuestionType).UNDER_EVALUATION)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, "評価中"))
                                                            : _createCommentVNode("", true),
                                                        (display.status == _unref(QuestionType).ACCEPTED)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, "受付済"))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_38, [
                                                    _createElementVNode("a", {
                                                        class: "title",
                                                        href: `/question/${display.id}`,
                                                        target: "_blank"
                                                    }, _toDisplayString(display.subject), 9, _hoisted_39),
                                                    _createElementVNode("a", {
                                                        class: "lead",
                                                        href: `/question/${display.id}`,
                                                        target: "_blank",
                                                        style: { "white-space": "pre-line" }
                                                    }, _toDisplayString(_unref(Formatter).formatCharOmit(display.content, 180)), 9, _hoisted_40)
                                                ]),
                                                _createElementVNode("div", _hoisted_41, [
                                                    _createElementVNode("div", _hoisted_42, [
                                                        _createElementVNode("p", _hoisted_43, [
                                                            _createElementVNode("span", null, _toDisplayString(display.answer_count), 1),
                                                            _cache[15] || (_cache[15] = _createTextVNode("回答 "))
                                                        ]),
                                                        _createElementVNode("p", _hoisted_44, [
                                                            _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-heart" }, null, -1)),
                                                            _createTextVNode(_toDisplayString(display.like_count), 1)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(Formatter).formatDate(display.created_at, 'YYYY年MM月DD日 HH:mm')), 1)
                                                ])
                                            ]));
                                        }), 256))
                                    ]),
                                    _createVNode(Pagination, {
                                        questions: props.questions
                                    }, null, 8, ["questions"])
                                ])
                            ]),
                            _createVNode(footerVue)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
